import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import HowToGuide from "@/components/organisms/common/HowToGuide/HowToGuide.vue";
import { firstBootStore } from "@/store/first-boot";
import { useCustomRouter } from "@/utils/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { replaceIgnoreError } = useCustomRouter();

const onClose = async () => {
  firstBootStore.completeFirstBoot();
  await replaceIgnoreError({ name: "Welcome" });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(HowToGuide, { onClose: onClose }))
}
}

})